/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import { TableCell, TableRow, Button, TextField } from "@mui/material";
import { Link, NavLink } from "react-router-dom";
import clsx from "clsx";
import ViewIcon from "../../../../../assets/images/icon_actions/View.svg";
import EditIcon from "../../../../../assets/images/icon_actions/Edit.svg";
import ElipsisIcon from "../../../../../assets/images/icon_actions/Elipsis.svg";
import DeleteIcon from "../../../../../assets/images/icon_actions/Delete Icon.svg";
import { Image, Space, Dropdown, Menu, Modal } from "antd";
import moment from 'moment';
import { customerPaymentBillHead } from "../../../../../config/constant";
import { capitalizeFirstLetter, currencyFormat, checkCRUDPermission, checkComponentPermission, getColumnWidth, idNamingConversion } from "../../../../../helpers/utilities";
import DeleteModal from "../../../../Shared/components/DeleteModal";
import { emptyValidation } from "../../../../../helpers/validation";
import { useDispatch, useSelector } from "react-redux";
import crudActions from "../../../../CRUD/redux/actions";
import usePrevious from "../../../../Shared/components/Previous";
import { toast } from 'react-toastify';
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import { AESEncrypt } from "../../../../../helpers/Crypto";
import SearchText from '../../../../Shared/components/SearchText';
//import infoMarkIcon from "../../../../../assets/images/icon_actions/infoMark.svg";


export const CustomerPaymentTable = (props) => {
    const { details, onRequestSort, sortOrder, sortBy, loadTasks, loadMore, search, loadMoreTask, loadMoreContent, roleManagement } = props;
    const { editDetails, editError, editLoader, createDetails, createError } = useSelector(state => state.crudReducer);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [reason, setReason] = useState('');
    const [paymentId, setPaymentId] = useState('');
    const [name, setName] = useState('');
    const dispatch = useDispatch();
    const [deleteModal, setDeleteModal] = useState(false);
    const [errorReason, setErrorReason] = useState(false);
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);

    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    //  const prevDeleteDetails = usePrevious(deleteDetails);

    const handleDeleteModal = (value) => {
        setDeleteModal(value);
    }

    const onDelete = (data) => {
        setDeleteModal(true);
        setPaymentId(data.id);
        setName(data?.serialNo);
    }

    const handleOk = () => {
        setReason('');
        setIsModalVisible(false);
    };

    const handleCancel = () => {
        setReason('');
        setIsModalVisible(false);
        setErrorReason(false);
    }

    const handlePaymentCancel = (data) => {
        setPaymentId(data.id);
        setIsModalVisible(true);
        setReason('');
    }

    const deletePayment = (e) => {
        e.preventDefault();
        let emptyReason = emptyValidation('Reason', reason);
        if (emptyReason.isValid) {
            changeStatus(paymentId, 'CANCELLED', reason);
        } else {
            if (emptyReason.errors) {
                setErrorReason(emptyReason.errors);
            }
        }
    }

    const changeStatus = (id, status, reason = '') => {
        let details = {
            paymentStatus: status
        };

        if (reason !== '') {
            details["reversalReason"] = reason;
        }

        let data = {
            type: status === 'CONFIRMED' ? crudActions.CREATE_DETAILS_START : crudActions.EDIT_DETAILS_START,
            url: status === 'CONFIRMED' ? `/customerPayment/${id}/confirmPayment` : 'customerPayment',
            title: 'Customer Payment',
            id: id,
            details: details
        }

        if (status === 'CANCELLED') {
            data['slug'] = "cancel";
        }

        dispatch(data);
    }

    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            toast.dismiss();
            //toast(editDetails);
            loadTasks();
            setReason('');
            setIsModalVisible(false);
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            let message = editError.error.message;
            toast.dismiss();
            toast.error(message);
        }
    }, [editDetails, editError]);


    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            toast.dismiss();
            //toast(editDetails);
            loadTasks();
            setReason('');
            setIsModalVisible(false);
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let message = createError.error.message;
            toast.dismiss();
            toast.error(message);
        }
    }, [createDetails, createError]);

    const classes = customStyles();
    // const collectLink = <a onClick={() => { }} href="/sales/sales-management/customer-payment/create">Collect Payment</a>;

    return (
        <>
            <CustomInfiniteScroll
                loadMore={loadMore}
                loadMoreContent={loadMoreContent}
                heads={customerPaymentBillHead}
                onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
                sortOrder={sortOrder}
                sortBy={sortBy}
                loadMoreTask={() => loadMoreTask()}
                details={details}
                component={
                    <>
                        {
                            !loadMore || details === '' ? (
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell className={classes.textAlignCenter} colSpan={customerPaymentBillHead.length}><div className={classes.loadMoreCircle}></div></TableCell>
                                </TableRow>
                            ) : (
                                <React.Fragment>
                                    {
                                        details && Array.isArray(details) && details.length > 0 ? details.map((data, i) => (
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} key={i} >
                                                <TableCell style={{ width: getColumnWidth(customerPaymentBillHead, 0) }}>
                                                    {
                                                        roleManagement !== '' && checkCRUDPermission('Customer Payment', 'view', 'Sales') ?
                                                            <Link id={idNamingConversion('View_' + data.id, 'customerPayment', 'Link')} style={{ width: getColumnWidth(customerPaymentBillHead, 0) }} to={`/sales/sales-management/customer-payment/${AESEncrypt(data.id)}/view`} className={clsx(classes.color, classes.bold)}>{data?.serialNo || '---'}</Link> : <span style={{ width: getColumnWidth(customerPaymentBillHead, 0) }}>{data?.serialNo || '---'}</span>
                                                    }
                                                </TableCell>
                                                <TableCell style={{ width: getColumnWidth(customerPaymentBillHead, 1) }}><span style={{ width: getColumnWidth(customerPaymentBillHead, 1) }}>{data?.customer?.name || '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(customerPaymentBillHead, 2) }}><span style={{ width: getColumnWidth(customerPaymentBillHead, 2) }}>{data?.customer?.serialNo || '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(customerPaymentBillHead, 3) }}><span style={{ width: getColumnWidth(customerPaymentBillHead, 3) }}>{moment(data.date).format('DD MMM YYYY')}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(customerPaymentBillHead, 4) }} className={classes.rightAlignAmount}><span style={{ width: getColumnWidth(customerPaymentBillHead, 0) }}>{'₹  '}{currencyFormat(data.paymentAmount)}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(customerPaymentBillHead, 5) }}><span style={{ width: getColumnWidth(customerPaymentBillHead, 0) }}>{data?.mop?.method || '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(customerPaymentBillHead, 6) }}><span style={{ width: getColumnWidth(customerPaymentBillHead, 0) }}><span style={{ display: "inline-block" }} className={clsx(classes.statusButton, { [classes.confirmedButton]: data.paymentStatus === 'CONFIRMED' }, { [classes.reversedButton]: data.paymentStatus === 'CANCELLED' })}>{capitalizeFirstLetter(data.paymentStatus)}</span></span></TableCell>
                                                <TableCell>
                                                    <Space direction="horizontal" align="center" size={[0, 0]} className={clsx(classes.iconPadding, classes.actionWidth)} >
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Customer Payment', 'view', 'Sales') &&
                                                            <Link id={idNamingConversion('View_' + data.id, 'customerPayment', 'Icon')} to={`/sales/sales-management/customer-payment/${AESEncrypt(data.id)}/view`}>
                                                                <Image src={ViewIcon} preview={false} />
                                                            </Link>
                                                        }
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Customer Payment', 'edit', 'Sales') &&
                                                            <Link id={idNamingConversion('Edit_' + data.id, 'customerPayment', 'Icon')} to={`/sales/sales-management/customer-payment/${AESEncrypt(data.id)}/edit`} className={clsx({ [classes.disabled]: data.paymentStatus === 'CONFIRMED' || data.paymentStatus === 'CANCELLED' || data.paymentStatus === 'REVERSED' })}>
                                                                <Image
                                                                    src={EditIcon}
                                                                    preview={false}
                                                                />
                                                            </Link>
                                                        }
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Customer Payment', 'deletable', 'Sales') &&
                                                            <NavLink id={idNamingConversion('Delete_' + data.id, 'customerPayment', 'Icon')} to={"#"} className={clsx({ [classes.disabled]: data.paymentStatus === 'CONFIRMED' || data.paymentStatus === 'CANCELLED' || data.paymentStatus === 'REVERSED' })} onClick={() => onDelete(data)}>
                                                                <Image src={DeleteIcon} preview={false} />
                                                            </NavLink>
                                                        }
                                                        <Dropdown
                                                            trigger={['click']}
                                                            placement={'bottomRight'}
                                                            overlay={
                                                                <Menu className={clsx(classes.groupMenu)}>
                                                                    <Menu.Item key="arrow" className={clsx(classes.accordionSubmenuArrow)}></Menu.Item>
                                                                    {
                                                                        roleManagement !== '' && checkComponentPermission('Customer Payment', 'Ellipsis Action', 'Cancel') && !data?.customerPaymentItems &&
                                                                        data.paymentStatus === 'CONFIRMED' && <Menu.Item key="confirmed">
                                                                            <NavLink to={'#'} id={idNamingConversion('Cancel_' + data.id, 'customerPayment', 'Icon')}
                                                                                onClick={() => handlePaymentCancel(data)}>Cancel</NavLink>
                                                                        </Menu.Item>
                                                                    }
                                                                    {
                                                                        roleManagement !== '' && checkComponentPermission('Customer Payment', 'Ellipsis Action', 'View') &&
                                                                        (data.paymentStatus === 'CANCELLED' || data.paymentStatus === 'REVERSED') && <Menu.Item key="cancel"><NavLink id={idNamingConversion('View_' + data.id, 'customerPayment', 'Icon')} to={`/sales/sales-management/customer-payment/${AESEncrypt(data.id)}/view`}>View</NavLink></Menu.Item>
                                                                    }
                                                                    {
                                                                        roleManagement !== '' && checkComponentPermission('Customer Payment', 'Ellipsis Action', 'Confirmation') &&
                                                                        data.paymentStatus === 'CREATED' && <Menu.Item key="created"><NavLink id={idNamingConversion('Confirm_' + data.id, 'customerPayment', 'Icon')} to={'#'} onClick={() => changeStatus(data.id, 'CONFIRMED')}>Confirm</NavLink></Menu.Item>
                                                                    }
                                                                </Menu>
                                                            }>
                                                            <Image id={idNamingConversion('Elipsis_' + data.id, 'customerPayment', 'Icon')} src={ElipsisIcon} preview={false} />
                                                        </Dropdown>
                                                    </Space>
                                                </TableCell>
                                            </TableRow>
                                        )) : (
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell className={classes.textAlignCenter} colSpan={customerPaymentBillHead.length}>
                                                    {
                                                        search !== '' ? <SearchText /> : <p style={{ lineHeight: 2 }} className={clsx(classes.noResultsText, classes.textAlignCenter)}>All Customer Payments will be listed here when transactions are recorded by the system</p>
                                                    }
                                                </TableCell>
                                            </TableRow>
                                        )
                                    }
                                </React.Fragment>
                            )
                        }

                    </>
                }
            />
            <Modal
                title={'Reason for Cancellation'}
                open={isModalVisible}
                onOk={() => handleOk()}
                onCancel={() => handleCancel()}
                className={clsx(classes.deletePopup, classes.removeUnderline)}
                footer={
                    [
                        <Button
                            key="Confirm"
                            type='submit'
                            color='primary'
                            variant="contained"
                            className={clsx(classes.modalBtn, { [classes.loading]: editLoader })}
                            onClick={(e) => deletePayment(e)}
                        >Confirm</Button>,
                    ]}
            >
                <TextField autoComplete='one-time-code'
                    label='Enter the reason for Cancellation'
                    fullWidth
                    variant={'standard'}
                    value={reason}
                    error={errorReason && true}
                    helperText={errorReason}
                    InputProps={{
                        classes: {
                            input: classes.textFieldColor,
                        }
                    }}
                    InputLabelProps={{
                        className: classes.textFieldLableColorCustom
                    }}
                    onChange={(e) => setReason(e.target.value)}
                />
            </Modal >
            <DeleteModal onClose={(v) => handleDeleteModal(v)} id={paymentId} loadTasks={() => loadTasks()} name={name} url={'customerPayment'} title={'Customer Payment'} visible={deleteModal} />
        </>
    )
}